import { useMutation } from '@tanstack/react-query';

import {
  type PointsAdjustmentRequestBody,
  type PointsAdjustmentResponse,
  createPointsAdjustment,
} from '~/services/LuxLoyalty';

interface UseAdjustPointsOptions {
  onSuccess?: (data: PointsAdjustmentResponse) => void;
  onError?: (error: Error) => void;
}

export function useAdjustPoints(options: UseAdjustPointsOptions = {}) {
  return useMutation({
    mutationFn: async (params: PointsAdjustmentRequestBody) => {
      return await createPointsAdjustment(params);
    },
    onSuccess: options.onSuccess,
    onError: options.onError,
  });
}
